/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React, { useState } from 'react';
// import { auth } from '../firebase';
// import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
//import { auth, db } from '../firebase';
//import { updatePassword, updateEmail, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
// import { doc, updateDoc } from 'firebase/firestore';
import AdminPayouts from '../components/AdminPayouts.tsx';
import UserPayouts from '../components/UserPayouts.tsx'; // NEW

interface SalesData {
  data?: {
    firstname?: string;
    lastname?: string;
    email?: string;
    isAdmin?: boolean;
    tags?: string[];
  };
}

interface MyAccountProps {
  salesData: SalesData;
}
const MyAccount = ({ salesData }: MyAccountProps) => {
//const MyAccount: React.FC<MyAccountProps> = ({ salesData }) => {
 
  const [message] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  // Check if user is admin
  const isAdmin = salesData?.data?.isAdmin || false;

  return (
    <>
      <div id="my-account" className="page-container">
        <h1>Dashboard</h1>

        {message && (
          <div className={`message ${message.type}`} role="alert" aria-live="polite">
            {message.text}
          </div>
        )}
        {isAdmin ? <AdminPayouts /> : <UserPayouts />}
      </div>
    </>
  );
};

export default MyAccount;
